import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import { icons } from "../../../constants";
import { Container } from "./styles";

const LoadingItem = () => {
  return (
    <Container>
      <Player
        autoplay={true}
        loop={true}
        controls={false}
        src={icons.loading}
        style={{
          width: "100%",
        }}
      />
    </Container>
  );
};

export default LoadingItem;
